import { Translation } from "react-i18next";
import React from "react";
import { Tooltip } from "antd";

export const columns = [
    {
        title: (
            <Translation>
                {(t, { i18n }) => <span>{t("shiftTitle.codeShift")}</span>}
            </Translation>
        ),
        sorter: true,
        dataIndex: "code",
        ellipsis: {
            showTitle: true,
        },
        render: (code) => (
            <Tooltip placement="topLeft" title={code}>
                {code}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.nameSHift")}>{t("shiftTitle.nameSHift")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "name",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.flexibleHours")}>{t("shiftTitle.flexibleHours")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "flexibleHours",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.timeIn")}>{t("shiftTitle.timeIn")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "timeIn",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.timeOut")}>{t("shiftTitle.timeOut")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "timeOut",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.timeBreak")}>{t("shiftTitle.timeBreak")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "timeBreak",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.endBreak")}>{t("shiftTitle.endBreak")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "endBreak",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.checkInFirst")}>{t("shiftTitle.checkInFirst")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "checkInFirst",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.checkInLater")}>{t("shiftTitle.checkInLater")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "checkInLater",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.totalHours")}>{t("shiftTitle.totalHours")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "totalHours",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        title: (
            <Translation>
                {(t, { i18n }) => <Tooltip placement="topLeft" title={t("shiftTitle.totalWork")}>{t("shiftTitle.totalWork")}</Tooltip>}
            </Translation>
        ),
        dataIndex: "totalWork",
        ellipsis: {
            showTitle: true,
        },
        render: (value) => (
            <Tooltip placement="topLeft" title={value}>
                {value}
            </Tooltip>
        ),
    },
    {
        dataIndex: "menu",
        width: '11%'
    },
];